

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};


	var swiperGrid = new Swiper(".grid-swiper .swiper", {
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		observer: true,
		spaceBetween: 10,
		observeParents: true,

		breakpoints: {
			200: {
				slidesPerView: 2,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
				grid: {
					rows: 2,
					fill: "row",
				},
			},

			1280: {
				slidesPerView: 5,
				spaceBetween: 35,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},

		navigation: {
			nextEl: ".grid-swiper .next",
			prevEl: ".grid-swiper .prev",
		},
	});




	var primarySwiper = new Swiper(".primary-banner .swiper", {
		slidesPerView: 1,
		observer: true,
		observeParents: true,
		preventInteractionOnTransition: false,
		speed: 1205,
		autoplay: false,
		lazy: {
			loadPrevNext: true,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		init: false,
		navigation: {
			nextEl: ".primary-banner .next",
			prevEl: ".primary-banner .prev",
		},
		pagination: {
			el: ".primary-banner .swiper-pagination",
			type: "bullets",
			clickable: true,
			renderBullet: function (index, className) {
				return `<span class="${className}" data-index="${index}"></span>`;
			},
		},
	});


	let progressInterval = null;
	let timer = null;
	const slideTimeout = 4000;

	// Function to reset and start progress track
	function startProgressTrack() {
		// Clear any existing interval
		if (progressInterval) {
			clearInterval(progressInterval);
		}

		// Get the progress track element
		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (!progressTrack) return;

		// Reset progress to 0%
		progressTrack.style.width = "0%";

		// Set up interval to increment width
		const intervalStep = 20; // Update every 20ms for smooth animation
		const increment = (intervalStep / slideTimeout) * 100;
		let progress = 0;

		progressInterval = setInterval(() => {
			progress += increment;
			if (progress >= 100) {
				clearInterval(progressInterval);
				progressTrack.style.width = "100%";
			} else {
				progressTrack.style.width = `${progress}%`;
			}
		}, intervalStep);
	}

	// Function to reset progress track
	function resetProgressTrack() {
		if (progressInterval) {
			clearInterval(progressInterval);
			progressInterval = null;
		}
		const progressTrack = document.querySelector(".primary-banner .progress-track");
		if (progressTrack) {
			progressTrack.style.width = "0%";
		}
	}


	// Function to handle video playback
	function handleVideoPlayback(slide) {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}
		resetProgressTrack();
		// Pause all videos first
		const allVideos = document.querySelectorAll(".primary-banner-video");
		allVideos.forEach((video) => {
			video.pause();
			video.currentTime = 0;
		});

		const videoElement = slide.querySelector("video");
		if (videoElement) {
			// Play the current slide's video
			startProgressTrack();
			videoElement.play().catch((error) => {
				timer = setTimeout(() => {
					primarySwiper.slideNext();
				}, slideTimeout);
			});

			videoElement.addEventListener(
				"ended",
				function () {
					if (primarySwiper.slides.length === 1) {
						videoElement.currentTime = 0;
						videoElement.play();
					} else {
						primarySwiper.slideNext();
					}
				},
				{ once: true }
			);
		} else {
			// If no video, set timer for next slide
			startProgressTrack();
			timer = setTimeout(() => {
				primarySwiper.slideNext();
			}, slideTimeout);
		}
	}

	primarySwiper.on("slideChangeTransitionEnd", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
	});
	primarySwiper.on("slideChangeTransitionStart", function () {
		resetProgressTrack();
	});

	primarySwiper.on("init", function () {
		const currentSlide = primarySwiper.slides[primarySwiper.activeIndex];
		handleVideoPlayback(currentSlide);
	});

	// Handle video click events
	const primaryBannerVideo = document.querySelectorAll(".primary-banner-video");
	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("click", function (event) {
			if (this.paused) {
				this.play();
				this.parentNode.classList.remove("pause");
			} else {
				this.pause();
				this.parentNode.classList.add("pause");
			}
		});
	});

	primarySwiper.init();








	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "bullets",
				clickable: true,
			},
		});
	});

	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 2000,
		spaceBetween: 15,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				spaceBetween: 20,
				slidesPerView: 8,
			},
			1400: {
				spaceBetween: 38,
				slidesPerView: 7,
			},
		},
	});


}